import Serializable from "@/core/misc/mixins/Serializable";
import Utils        from "@/core/utils/Utils";

/**
 * Сущность-указатель для универсальных сервисов/подсистем.
 *
 * id — целое число (product, partner) либо строковый uid (file).
 */
class EntityPointer extends Serializable {
	/** Тип сущности */
	typeName: string;
	id: number | string;
	/** Имя сущности для вывода в интерфейсе */
	name?: string;
	/** Версия сущности на момент указания. Бэк домешивает её для записей фида. */
	version?: number;

	static fromServer(data: any, result = new EntityPointer()) {
		super.fromServer(data, result)
		return result;
	}

	/**
	 * Создаёт указатель либо null, если id не задан.
	 *
	 * Нужен для сборки списков указателей без проверок на стороне вызова:
	 * пустые отсеиваются одним filter в месте сборки.
	 */
	static make(typeName: string, id: number | string | null | undefined, name?: string, version?: number): EntityPointer | null {
		if (Utils.isNullOrUndefined(id)) {
			return null;
		} else {
			return new EntityPointer(typeName, id, name, version);
		}
	}

	/**
	 * Отсеивает пустые указатели из списка.
	 *
	 * Вместе с make позволяет собирать списки указателей литералом,
	 * без проверок и без ручной типизации предиката фильтра.
	 */
	static collect(pointers: (EntityPointer | null)[]): EntityPointer[] {
		return pointers.filter((pointer): pointer is EntityPointer => pointer !== null);
	}

	constructor(typeName: string, id: number | string, name?: string, version?: number) {
		super();

		this.typeName = typeName;
		this.id = id;
		this.name = name;
		this.version = version;
	}

  toString() {
    return this.name;
  }

}

export default EntityPointer;